import React from "react";

export const Loader = () => {
  return (
    <div className="loader-wrapper">
      <span className="loader"></span>
    </div>
  );
};
